import { useContext, useState } from "react";
import { Navigate } from "react-router";
import { UserContext } from "../UserContext";
import config from "../config";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [alert, setAlert] = useState({ message: "", type: "" });

  const { setUserInfo } = useContext(UserContext);

  async function login(ev) {
    ev.preventDefault();
    const response = await fetch(`${config.apiUrl}/login`, {
      method: "POST",
      body: JSON.stringify({ username, password }),
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });

    if (response.ok) {
      const userInfo = await response.json();
      setUserInfo(userInfo);
      setRedirect(true);
      setAlert({ message: "Login successful!", type: "success" });
    } else {
      setAlert({ message: "Invalid username or password.", type: "error" });
    }
  }

  if (redirect) {
    return <Navigate to={"/"} />;
  }

  return (
    <div className="validation-box">
      <div className="auth">
        <h1>Login</h1>
        <form className="login" onSubmit={login}>
          <input
            type="text"
            placeholder="username"
            value={username}
            onChange={(ev) => setUsername(ev.target.value)}
          />
          <input
            type="password"
            placeholder="password"
            value={password}
            onChange={(ev) => setPassword(ev.target.value)}
          />
          <button className="forms-button">
            <span>Login</span>
          </button>
        </form>
      </div>
      {alert.message && (
        <div className={`alert ${alert.type}`}>{alert.message}</div>
      )}
    </div>
  );
}
